<web-settings-body>
    @if (screen() === screenEnum.Main) {
        <web-settings-breadcrumbs>
            <div class="breadcrumb-icon">
                <a [tooltip]="'site_styles' | translate" placement="bottom" (click)="setSelectedTheme()">
                    <img
                        src="./assets/img/websites/lpc-theme-settings-icon.svg"
                        class="first-breadcrumb-icon"
                        alt="lpc-theme-settings-icon"
                    />
                </a>
                <img
                    src="./assets/img/websites/lpc-breadcrumb-arrow-icon.svg"
                    class="breadcrumb-arrow-icon"
                    alt="lpc-breadcrumb-arrow-icon"
                />
            </div>
            <div class="breadcrumb-icon">
                <img
                    src="./assets/img/websites/lpc-block-icon.svg"
                    class="first-breadcrumb-icon"
                    alt="lpc-block-icon"
                />
            </div>
            <div class="breadcrumb-text">
                <span>{{ "control_block" | translate }}</span>
            </div>
        </web-settings-breadcrumbs>
    } @else {
        <web-settings-breadcrumbs>
            <div class="breadcrumb-icon">
                <a (click)="togglePanelSettings()">
                    <img
                        src="./assets/img/websites/lpc-back-icon.svg"
                        class="first-breadcrumb-icon"
                        alt="lpc-back-icon"
                    />
                </a>
            </div>
            <div class="breadcrumb-text">
                <span>{{ "block_display_condition_setting_title" | translate }}</span>
            </div>
        </web-settings-breadcrumbs>
    }

    @if (screen() === screenEnum.Main) {
        <a [href]="'knowledge_base_block_link' | translate" class="kb-link" target="_blank">
            <span class="small sp-icon icon-info"> </span> {{ "knowledge_base_block_tooltip" | translate }}
            <span class="color-light small sp-icon icon-outgoing"> </span>
        </a>

        <div class="panel-options-body overflow-wrapper">
            <div class="form form-horizontal">
                <div class="form-row">
                    <div class="form-group mb-10">
                        <div class="col-xs-12 device-toggle-wrapper">
                            <web-device-toggle />

                            <web-synchronize-style-toggle
                                [active]="syncWithDesktop()"
                                (click)="setSynchronizeStyle()"
                            />
                        </div>
                    </div>

                    <div class="form-group mb-0">
                        <p class="col-xs-12 help-block text-muted small">
                            {{ device() + "_device_hint" | translate }}
                        </p>
                    </div>

                    <!--
                        One section for every breakpoint: `device()` picks which values it
                        shows and every setter writes through `write()`, which fans the edit
                        out to all three while style synchronisation is on.
                    -->
                    <div class="form-group">
                        <label class="col-xs-9 control-label">
                            {{ "control_background_color" | translate }}
                        </label>
                        <div class="col-xs-3">
                            <web-color-picker
                                [color]="backgroundColor()"
                                (colorChangeEvent)="setBackgroundColor($event)"
                            />
                        </div>
                    </div>

                    <div class="form-group mb-20">
                        <label class="col-xs-12">
                            {{ "control_margin_top_bottom" | translate }}
                        </label>
                        <div class="col-xs-6">
                            <sp-input-num
                                prefixImgUrl="./assets/img/websites/lpc-top-spacing-icon.svg"
                                suffixText="px"
                                [min]="PADDING_MIN"
                                [max]="PADDING_MAX"
                                [value]="padding()?.top"
                                (valueChange)="setPadding('top', $event)"
                            />
                        </div>
                        <div class="col-xs-6">
                            <sp-input-num
                                prefixImgUrl="./assets/img/websites/lpc-bottom-spacing-icon.svg"
                                suffixText="px"
                                [min]="PADDING_MIN"
                                [max]="PADDING_MAX"
                                [value]="padding()?.bottom"
                                (valueChange)="setPadding('bottom', $event)"
                            />
                        </div>
                    </div>

                    <div class="form-group mb-20">
                        <label class="col-xs-12">
                            {{ "control_margin_left_right" | translate }}
                        </label>
                        <div class="col-xs-6">
                            <sp-input-num
                                prefixImgUrl="./assets/img/websites/lpc-left-spacing-icon.svg"
                                suffixText="px"
                                [min]="PADDING_MIN"
                                [max]="PADDING_MAX"
                                [value]="padding()?.left"
                                (valueChange)="setPadding('left', $event)"
                            />
                        </div>
                        <div class="col-xs-6">
                            <sp-input-num
                                prefixImgUrl="./assets/img/websites/lpc-right-spacing-icon.svg"
                                suffixText="px"
                                [min]="PADDING_MIN"
                                [max]="PADDING_MAX"
                                [value]="padding()?.right"
                                (valueChange)="setPadding('right', $event)"
                            />
                        </div>
                    </div>

                    <div class="mb-15">
                        <web-background-image-settings
                            [background]="background()"
                            [disabled]="!!backgroundVideo()"
                            [allowScrollEffect]="!pinOnTheTop() && !pinOnTheBottom()"
                            (backgroundChange)="setBackground($event)"
                            (showEditImageModalEvent)="showEditImageModal()"
                            (unsplashClickRequested)="openUnsplashModal()"
                        />
                    </div>

                    <web-background-video-settings
                        [video]="backgroundVideo()"
                        [disabled]="!!backgroundImage()"
                        (videoChange)="setBackgroundVideo($event)"
                    />

                    <!-- The two edges take the same controls; only the shape strip differs. -->
                    @for (edge of ["top", "bottom"]; track edge) {
                        @let divider = edge === "top" ? topDivider() : bottomDivider();

                        <div class="form-group mb-10">
                            <label class="col-xs-9 control-label">
                                {{ "control_" + edge + "_divider" | translate }}
                            </label>
                            <div class="col-xs-3 text-right">
                                <sp-switch
                                    [active]="!!divider?.isEnabled"
                                    (toggleActiveEvent)="setDividerEnabled($any(edge), $event)"
                                />
                            </div>
                        </div>

                        @if (divider?.isEnabled) {
                            <div class="well well-sm mb-15">
                                <div class="form-group mb-15">
                                    <div class="appearance-wrapper">
                                        @for (variant of shapeDividerVariants; track variant) {
                                            <div
                                                class="appearance-block"
                                                [class.active]="divider?.view === variant"
                                                (click)="setDivider($any(edge), { view: variant })"
                                            >
                                                <img
                                                    src="./assets/img/websites/shape-divider/lpc-shape-divider-{{
                                                        edge === 'bottom' ? 'b-' : ''
                                                    }}{{ variant }}.svg"
                                                />
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div class="form-group mb-15">
                                    <label class="col-xs-7 control-label">
                                        {{ "control_divider_color" | translate }}
                                    </label>
                                    <div class="col-xs-5">
                                        <web-color-picker
                                            [hideGradient]="true"
                                            [color]="divider?.color"
                                            (colorChangeEvent)="setDividerColor($any(edge), $event)"
                                        />
                                    </div>
                                </div>

                                <div class="form-group mb-15">
                                    <label class="col-xs-7 control-label">
                                        {{ "control_divider_height" | translate }}
                                    </label>
                                    <div class="col-xs-5">
                                        <sp-input-num
                                            suffixText="px"
                                            [min]="10"
                                            [max]="400"
                                            [value]="divider?.height"
                                            (valueChange)="setDivider($any(edge), { height: $event })"
                                        />
                                    </div>
                                </div>

                                <div class="form-group mb-15">
                                    <label class="col-xs-9 control-label">
                                        {{ "control_divider_repeat" | translate }}
                                    </label>
                                    <div class="col-xs-3">
                                        <sp-input-num
                                            [min]="1"
                                            [max]="5"
                                            [value]="divider?.repeat"
                                            (valueChange)="setDivider($any(edge), { repeat: $event })"
                                        />
                                    </div>
                                </div>

                                <div class="form-group mb-10">
                                    <label class="control-label col-xs-7">
                                        {{ "control_divider_flip" | translate }}
                                    </label>
                                    <div class="col-xs-5">
                                        <div
                                            class="btn-group btn-group-justified btn-group-with-tooltip three-items"
                                            data-toggle="buttons"
                                        >
                                            <button
                                                class="btn btn-grey"
                                                [class.active]="
                                                    divider?.horizontalFlip === EBlockShapeDividerFlip.HORIZONTAL
                                                "
                                                (click)="toggleDividerFlip($any(edge), 'horizontal')"
                                            >
                                                <img
                                                    src="./assets/img/websites/lpc-flip-horizontal-icon.svg"
                                                    alt="Horizontal"
                                                />
                                            </button>
                                            <button
                                                class="btn btn-grey"
                                                [class.active]="
                                                    divider?.verticalFlip === EBlockShapeDividerFlip.VERTICAL
                                                "
                                                (click)="toggleDividerFlip($any(edge), 'vertical')"
                                            >
                                                <img
                                                    src="./assets/img/websites/lpc-flip-vertical-icon.svg"
                                                    alt="Vertical"
                                                />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    }

                    <div class="form-group mb-10">
                        <label class="control-label col-xs-9">
                            {{ "control_contour" | translate }}
                        </label>
                        <div class="col-xs-3 control-switch text-right">
                            <sp-switch [active]="isBorder()" (toggleActiveEvent)="setIsBorder($event)" />
                        </div>
                    </div>

                    @if (isBorder()) {
                        <sp-advanced-border-settings
                            [borderSettings]="borderSettings()"
                            (valueChangeEvent)="setAdvancedBorderSettings($event)"
                        />
                    }

                    <div class="form-group mb-0">
                        <div class="col-xs-12">
                            <hr class="panel-options-divider" />
                        </div>
                    </div>

                    <div class="form-group mb-20">
                        <label class="col-xs-9 control-label">
                            {{ "control_full_width" | translate }}
                        </label>
                        <div class="col-xs-3 text-right">
                            <sp-switch [active]="isFullWidth()" (toggleActiveEvent)="setIsFullWidth($event)" />
                        </div>
                    </div>

                    <div class="form-group mb-20">
                        <label class="col-xs-9 control-label">
                            {{ "control_full_height" | translate }}
                        </label>
                        <div class="col-xs-3 text-right">
                            <sp-switch [active]="isFullHeight()" (toggleActiveEvent)="setIsFullHeight($event)" />
                        </div>
                    </div>

                    <div class="form-group mb-20">
                        <label class="control-label col-xs-6">
                            {{ "control_hide_block" | translate }}
                        </label>
                        <div class="col-xs-6">
                            <div
                                class="btn-group btn-group-justified btn-group-with-tooltip three-items"
                                data-toggle="buttons"
                            >
                                <button
                                    class="btn btn-grey"
                                    [tooltip]="onDesktopTooltip"
                                    [class.active]="hidden()?.desktop"
                                    (click)="toggleHiddenOn('desktop')"
                                >
                                    <ng-template #onDesktopTooltip>
                                        {{ "control_hide_on_desktop_tooltip" | translate }}
                                    </ng-template>
                                    <img src="./assets/img/websites/lpc-desktop-icon.svg" alt="Hide on desktop" />
                                </button>
                                <button
                                    class="btn btn-grey"
                                    [tooltip]="onTabletTooltip"
                                    [class.active]="hidden()?.tablet"
                                    (click)="toggleHiddenOn('tablet')"
                                >
                                    <ng-template #onTabletTooltip>
                                        {{ "control_hide_on_tablet_tooltip" | translate }}
                                    </ng-template>
                                    <img src="./assets/img/websites/lpc-tablet-icon.svg" alt="Hide on tablet" />
                                </button>
                                <button
                                    class="btn btn-grey"
                                    [tooltip]="onMobileTooltip"
                                    [class.active]="hidden()?.mobile"
                                    (click)="toggleHiddenOn('mobile')"
                                >
                                    <ng-template #onMobileTooltip>
                                        {{ "control_hide_on_mobile_tooltip" | translate }}
                                    </ng-template>
                                    <img src="./assets/img/websites/lpc-mobile-icon.svg" alt="Hide on mobile" />
                                </button>
                            </div>
                        </div>
                    </div>

                    @if (canPinToTop()) {
                        <div class="form-group mb-20">
                            <label class="col-xs-9 control-label">
                                {{ "control_top_fixed_block" | translate }}
                            </label>
                            <div class="col-xs-3 text-right">
                                <sp-switch [active]="pinOnTheTop()" (toggleActiveEvent)="setPinOnTheTop($event)" />
                            </div>
                        </div>
                    }

                    @if (canPinToBottom()) {
                        <div class="form-group mb-20">
                            <label class="col-xs-9 control-label">
                                {{ "control_bottom_fixed_block" | translate }}
                            </label>
                            <div class="col-xs-3 text-right">
                                <sp-switch
                                    [active]="pinOnTheBottom()"
                                    (toggleActiveEvent)="setPinOnTheBottom($event)"
                                />
                            </div>
                        </div>
                    }

                    @if (isAdmin()) {
                        <hr class="panel-options-divider" />
                        <web-block-library-addon [blockId]="entity().id" />
                    }
                </div>
            </div>

            <div class="display-condition-control small">
                <div class="d-flex align-items-center justify-content-between">
                    <div class="display-condition-title">
                        @let condition = displayCondition();
                        <span>
                            {{
                                (condition.state === "visible"
                                    ? "block_display_condition_show_state"
                                    : "block_display_condition_hide_state"
                                ) | translate
                            }}
                        </span>
                        <ul>
                            @for (item of condition.conditions; track $index; let isLast = $last) {
                                <li>
                                    <div class="text-muted">
                                        <span class="condition-type">
                                            {{ "block_display_condition_type_" + item.conditionType | translate }}
                                        </span>
                                        @if (item.conditionType !== "always") {
                                            <span> • </span>
                                            <span class="condition-equality">
                                                {{ "block_display_condition_equality_" + item.equality | translate }}
                                            </span>
                                            <span class="condition-value">{{ getDisplayConditionValue(item) }}</span>
                                        }
                                    </div>
                                    @if (!isLast) {
                                        <span class="operator-value color-light">
                                            {{ "block_display_condition_operator_" + condition.operator | translate }}
                                        </span>
                                    }
                                </li>
                            }
                        </ul>
                    </div>
                    <button class="btn btn-link pull-right" (click)="togglePanelSettings()">
                        <span class="sp-icon icon-ap-edit"></span>
                    </button>
                </div>
            </div>

            <div class="mt-20">
                <web-custom-id
                    [displayId]="displayId()"
                    [disabled]="isDisplayIdEditingDisabled()"
                    (valueChangeEvent)="setDisplayId($event)"
                />
            </div>
        </div>
    } @else {
        <web-block-display-condition-settings
            [blockCondition]="displayCondition()"
            (valueChangeEvent)="setDisplayCondition($event)"
        />
    }
</web-settings-body>
